module.exports = __webpack_public_path__ + "static/screenshot-2-9782bce78fde566e327b024c2ff2e402.png";